import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

import BRAND_DETAILS_FRAGMENT from './brand-details-fragment'

const BrandCurationTaskDetailsFragment = gql`
  fragment BrandCurationTaskDetailsFragment on BrandCurationTask {
    id
    taskStatus
    awaitingStatus
    problemReason
    problemComment
    updatedAt
    curatedAt
    reopenedAt
    createdAt
    qadAt
    qcdAt
    isDeleted
    isReopenedManually
    isQaDone
    isQcDone
    areLocationCuisineTypeAndLocationTypeSameAsBrand
    isCurationDone
    tags
    menuCurationTaskId

    reopenedBy {
      ...SimpleUserFragment
    }

    createdBy {
      ...SimpleUserFragment
    }

    updatedBy {
      ...SimpleUserFragment
    }

    curatedBy {
      ...SimpleUserFragment
    }

    brand {
      ...BrandDetailsFragment
    }

    assignedCurator {
      ...SimpleUserFragment
    }

    assignedQa {
      ...SimpleUserFragment
    }

    assignedQc {
      ...SimpleUserFragment
    }
  }
  ${SIMPLE_USER_FRAGMENT}
  ${BRAND_DETAILS_FRAGMENT}
`

export default BrandCurationTaskDetailsFragment
